import BaseEndpoint from "../common/BaseEndpoint";

const apiPath = '/api/v0/news'


class NewsEndpoint extends BaseEndpoint {
    list(params = null) {
        if (typeof params == 'string') {
            return this.client.$get(apiPath + params)
        } else {
            return this.client.$get(apiPath, {params: params})
        }
    }

    detail(id, params = null) {
        return this.client.$get(apiPath + '/' + id, {params: params}).catch(err => {
            console.log('Unsuccessful response: ', err);
        })
    }

    update(id, fields) {
        if (typeof fields.append !== 'undefined') {
            fields.append('_method', 'PUT')
        } else {
            fields._method = 'PUT'
        }
        return this.client.$post(`${apiPath}/${id}`, fields);
    }

    add(fields) {
        return this.client.$post(`${apiPath}`, fields);
    }

    update_state(fields) {
        fields.data._method = 'PUT'
        return this.client.$post(apiPath + '/' + fields.id, fields.data)
    }

    del(id) {
        return this.client.$axios.delete(apiPath + '/' + id)
    }
}

export default NewsEndpoint;
